import LogDown from 'logdown';

const noop = () => {};

const customize = (logdownInstance) => {

    const isObject = variable => variable !== null &&
        variable instanceof Array === false &&
        typeof variable === 'object';

    const loggerMethodKeys = Object
        .keys(logdownInstance)
        .filter(method => typeof logdownInstance[method] === 'function');

    const pristineLoggerMethods = loggerMethodKeys.reduce((acc, methodKey) => {

        acc[methodKey] = logdownInstance[methodKey];
        return acc;

    }, {});

    const formatText = (stringArray) => {

        const response = [];

        const textStyling = [
            'font-weight: 100',
        ].join(';');

        const successColors = [
            'color: #0e3e14',
            'background: #2ECC40',
            'font-size: 12px',
            'padding: 2px 4px',
            'font-weight: 200',
        ].join(';');

        const errorColors = [
            'color: #FFFFFF',
            'background: #E7040F',
            'font-size: 12px',
            'padding: 2px 4px',
            'font-weight: 200',
        ].join(';');

        const [type, cmd = '', ...rest] = stringArray;

        if (cmd !== '') {

            const isError = cmd.indexOf('ERROR') > -1;
            const colors = isError ?
                errorColors :
                successColors;

            response.push(`%c ${type} %c ${cmd}`, textStyling, colors, ...rest);

        } else {

            response.push(`%c ${type}`, textStyling, ...rest);

        }


        return response;

    };

    loggerMethodKeys.forEach((key) => {

        const debuggingIsDisabled = !CWCONFIG.features.debug;
        if (debuggingIsDisabled) {

            logdownInstance[key] = noop;

        } else {

            logdownInstance[key] = (...args) => {

                if (isObject(args[0])) {

                    const {
                        type = '', cmd = '', data = null, ...rest
                    } = args[0];

                    if (data !== null
                        && pristineLoggerMethods.groupCollapsed
                        && pristineLoggerMethods.groupEnd
                    ) {

                        // Function.prototype.apply.call(logFn, console, args);
                        pristineLoggerMethods.groupCollapsed
                            .apply(logdownInstance, formatText([type, cmd]));
                        pristineLoggerMethods[key].apply(logdownInstance, [{ ...data, rest }]);
                        pristineLoggerMethods.groupEnd.apply(logdownInstance);

                    } else {

                        pristineLoggerMethods[key]
                            .apply(logdownInstance, formatText([type, cmd, ...rest]));

                    }
                    return false;

                }

                return pristineLoggerMethods[key].apply(logdownInstance, [...args]);

            };

        }


    });

    return logdownInstance;


};

const createLogger = (opts) => {

    const APP_PREFIX = 'CW-';

    const { prefix = 'App', prefixColor = '#AAA' } = opts;

    const finalPrefix = APP_PREFIX.concat(prefix);

    const log = customize(new LogDown(finalPrefix, {
        prefixColor,
    }));

    alignPrefixes();

    return log;

};

function alignPrefixes() {

    const longest =
        LogDown._instances.sort((a, b) => b.opts.prefix.length - a.opts.prefix.length)[0];

    LogDown._instances
        .forEach((instance) => {

            const padding = new Array(Math.max((longest.opts.prefix.length - instance.opts.prefix.length) + 1, 0)).join(' ');
            instance.opts.prefix += padding;

        });

}

export default createLogger;



// WEBPACK FOOTER //
// ./scripts/common/services/logging/createLogger.js